import { useStore } from '@/components/store/Store';

/**
 * Returns the IDs of museums that the current user can access
 * and that are associated with the given application ID.
 */
export function useAccessibleMuseumIds(applicationId: string): number[] {
  const { state } = useStore();
  const museums = state.currentUser?.cura_data?.appAccess?.museums;

  return (
    museums
      ?.filter((museum) => museum.applications?.some((app) => app.id === applicationId))
      .map((museum) => museum.id) ?? []
  );
}
